<template>
  <div style="position:relative;">
    <cjm-input @blur="handleBlur" ref="input" :value="inputValue" @queryInput="handleInput" type="text" :maxlength="99999" name="" height=80 >
      <span slot="prepend" class="iconfont icon-yuan"></span>
    </cjm-input>
    <div class="searchBth" v-tap.prevent="{ methods : search }">
      查询
    </div>
  </div>
</template>
<script>
  import cjmInput from '../../components/common/input.vue'
  import utils from '../../utils';

  export default {
    data(){
      return {
        inputValue: this.input
      }
    },
    props: ['value'],
    components: {
      cjmInput
    },
    watch: {
      value(val){
        this.inputValue = val;
      }
    },
    methods: {
      handleBlur(){
        this.$refs.input.focus();
      },
      search(){
        document.body.click();
        setTimeout(() => {
          this.$emit('query', this.inputValue)
        }, 100)
      },
      handleInput(code) {
        this.inputValue = code;
        this.$emit('queryInput', code);
      }
    },
    created(){
      this.inputValue = this.value;

      var code = utils.getSearch().code;
      if (code) {
        document.body.className += ' not-show';
        this.search();
      }
      setTimeout(() => {
        document.body.className = document.body.className.replace('not-show', '');
      }, 500);
    },
    mounted(){
      this.$refs.input.focus();
    }
  }
</script>
<style lang="less">
  body.not-show {
    opacity: 0;
  }
</style>
<style lang="less" scoped>
  @import '../../assets/less/base.less';

  @input-height: 80px;
  @border-radius: 8px;
  input {
    width: 100%;
    padding-left: @input-height+12;
    height: @input-height;
    font-size: @font-size-normal;
    margin-bottom: 50px;
    border: 1px solid @color-gray;

  }

  .iconfont {
    display: inline-block;
    width: @input-height;
    height: @input-height;
    line-height: @input-height;
    font-size: 52px;
    text-align: center;
    background: @color-gray;
    color: lighten(@color-black, 60%);
    border-bottom-left-radius: @border-radius;
    border-top-left-radius: @border-radius;
  }

  .searchBth {
    margin-top: 42px;
    background: @color-orange;
    color: @color-white;
    font-size: @font-size-normal;
    font-color: @font-color-normal;
    text-align: center;
    height: @input-height;
    line-height: @input-height;
    border-radius: @border-radius;
  }
</style>



// WEBPACK FOOTER //
// input-search.vue?1e82dc82